import { app } from '../../../../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.directory-integration.manage.connection-scim', {
        url: '/connection-scim',
        component: 'companyDirectoryIntegrationManageConnectionScim',
        resolve: {
            conConfig,
        },
    });
}

/** @ngInject */
function conConfig(companyId, directoryId, DirectoriesResource) {
    return DirectoriesResource.getScimConfig(companyId, directoryId);
}



// WEBPACK FOOTER //
// ./src/portal/states/company/directory-integration/manage/scim/connection/directory-manage-connection-scim.state.js